import styled from 'styled-components'

export const MessageContainer = styled.div`
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  background: linear-gradient(to bottom, #f0f2f5 0%, #e8eaed 100%);
  border-radius: 0 0 8px 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;

    &:hover {
      background: rgba(0, 0, 0, 0.3);
    }
  }
`

export const DateDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;

  span {
    background: rgba(0, 0, 0, 0.05);
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    color: #65676b;
    font-weight: 500;
  }
`

export const MessageWrapper = styled.div<{ isOutgoing: boolean }>`
  display: flex;
  flex-direction: ${props => (props.isOutgoing ? 'row-reverse' : 'row')};
  align-items: flex-end;
  margin-bottom: 12px;
  animation: messageSlideIn 0.3s ease-out;

  @keyframes messageSlideIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const MessageBubble = styled.div<{ isOutgoing: boolean }>`
  max-width: 65%;
  min-width: 100px;
  padding: 10px 14px;
  border-radius: 18px;
  position: relative;
  word-wrap: break-word;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);

  ${props =>
    props.isOutgoing
      ? `
    background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
    color: white;
    border-bottom-right-radius: 4px;
    margin-right: 8px;
    
    .message-text {
      color: white;
    }
    
    .message-time {
      color: rgba(255, 255, 255, 0.8);
    }
  `
      : `
    background: white;
    color: #000;
    border-bottom-left-radius: 4px;
    margin-left: 8px;
    
    .message-text {
      color: #050505;
    }
    
    .message-time {
      color: #65676b;
    }
  `}

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
`

export const MessageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MessageText = styled.div`
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
`

export const MessageTime = styled.div`
  font-size: 11px;
  margin-top: 4px;
  text-align: right;
  opacity: 0.9;
`

export const AvatarWrapper = styled.div`
  flex-shrink: 0;
  .ant-avatar {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
`

export const SenderName = styled.span<{ isOutgoing: boolean }>`
  font-size: 12px;
  font-weight: 600;
  color: ${props => (props.isOutgoing ? 'rgba(255, 255, 255, 0.9)' : '#1890ff')};
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #8c8c8c;

  .anticon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
  }
`


export const MessageImage = styled.img`
  max-width: 300px;
  max-height: 400px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 8px;
  object-fit: cover;
  display: block;
  position: relative;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
`
